import store from '../store/store';

const CPRHome = () => import('@/view/v4/CPR/Home');
const CPRMenu = () => import('@/view/v4/CPR/Menu');
const CPRSimulationCharacter = () =>
  import('@/view/v4/CPR/SimulationCharacter');
const CPRSimulation = () => import('@/view/v4/CPR/Simulation');
const CPRSimulationSummary = () => import('@/view/v4/CPR/SimulationSummary');
const CPRLessonSelect = () => import('@/view/v4/CPR/LessonSelect');
const CPRLesson = () => import('@/view/v4/CPR/LessonContent');
const CPRSummary = () => import('@/view/v4/CPR/Summary');
const CPRVideo = () => import('@/view/v4/CPR/Video');
const Question = () => import('@/view/v4/CPR/Question');
const Preview = () => import('@/view/v4/CPR/Preview');
const CPRSummaryFinal = () => import('@/view/v4/CPR/SummaryFinal');
const CPRSummaryTable = () => import('@/view/v4/CPR/SummaryTable');

const ifAuthenticated = (to, from, next) => {
  if (store.getters['auth/userStatus']) {
    let courseCode = '';
    let enroll = store.getters['necessary/getUserEnrolledCourse'];
    next();
  } else {
    next('/homepage');
  }
};

export default [
  {
    path: '/v4/CPR',
    name: 'v4CPR',
    component: CPRHome,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/v4/CPRmenu',
    name: 'v4CPR-MENU',
    component: CPRMenu,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/v4/CPRmenu',
    name: 'v4CPRMENU',
    component: CPRMenu,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/v4/CPR/lifesaver',
    name: 'v4CPRlifesaver',
    component: CPRSimulationCharacter,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/v4/CPR/simulation/:id',
    name: 'v4CPRSimulation',
    component: CPRSimulation,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/v4/CPR/lifesaverSummary',
    name: 'v4CPRlifesaverSummary',
    component: CPRSimulationSummary,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/v4/CPR/cprkids',
    name: 'v4CPRKids',
    component: CPRLessonSelect,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/v4/CPR/lessonContent/:id',
    name: 'v4CPRcontent',
    component: CPRLesson,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/v4/CPR/question',
    name: 'v4CPRQuestion',
    component: Question,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/v4/CPR/preview/:id',
    name: 'v4CPRpreview',
    component: Preview,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/v4/CPR/yourtruth',
    name: 'v4CPRSummaryFinal',
    component: CPRSummaryFinal,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/v4/CPR/thetruthuntold',
    name: 'v4CPRVideo',
    component: CPRVideo,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/v4/CPR/summary/:id',
    name: 'v4CPRSummary',
    component: CPRSummary,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/v4/CPR/yourtruth/score',
    name: 'v4CPRSummaryTable',
    component: CPRSummaryTable,
    beforeEnter: ifAuthenticated,
  },
];
